import { Component, OnInit } from '@angular/core';
import { ExportService } from 'app/reports/services/export.service';
import { ChartOptions, ChartType, ChartDataSets } from 'chart.js';
import { Label,SingleDataSet ,Color} from 'ng2-charts'
declare var $:any;
@Component({
  selector: 'app-graphical-paitent-registration-report',
  templateUrl: './graphical-paitent-registration-report.component.html',
  styleUrls: ['./graphical-paitent-registration-report.component.scss']
})
export class GraphicalPaitentRegistrationReportComponent implements OnInit {
   
  pageHeading:any;
  isShowDivIf:boolean = false;
  pname:any;
  flag:any;
  startdate;
  enddate;

  public barChartOptions:any = {
    scaleShowVerticalLines: false,
    responsive: true,
    scaleShowValues: true,
    scaleValuePaddingX: 10,
    scaleValuePaddingY: 10,
    animation: {
      onComplete: function () {
          var chartInstance = this.chart,
              ctx = chartInstance.ctx;

          ctx.textAlign = 'center';
          ctx.textBaseline = 'bottom';

          this.data.datasets.forEach(function (dataset, i) {
              var meta = chartInstance.controller.getDatasetMeta(i);
              meta.data.forEach(function (bar, index) {
                  var data = dataset.data[index];
                  ctx.fillText(data, bar._model.x, bar._model.y - 5);
              });
          });
      },
      onProgress: function () {
          var chartInstance = this.chart,
              ctx = chartInstance.ctx;

          ctx.textAlign = 'center';
          ctx.textBaseline = 'bottom';

          this.data.datasets.forEach(function (dataset, i) {
              var meta = chartInstance.controller.getDatasetMeta(i);
              meta.data.forEach(function (bar, index) {
                  var data = dataset.data[index];
                  ctx.fillText(data, bar._model.x, bar._model.y - 5);
              });
          });
      }
  }
    };

  //pie chart 
  public pieChartOptions: ChartOptions = {
    responsive: true,
    
  };
  
  public pieChartLabels: Label[] = [['New Patient'],['Total Patient']];
  public pieChartData: SingleDataSet = [50,100];
  public pieChartType: ChartType = 'pie';
  public pieChartLegend = true;
  public pieChartPlugins = [];
  //Bar Chat 
  public barChartLabels: Label[];
  public barChartType: ChartType = 'bar';
  public barChartLegend = true;
  public barChartPlugins = [];
  public barChartData: ChartDataSets[];
  //line chart
  lineChartOptions:any = {
    scaleShowVerticalLines: false,
    responsive: true,
    scaleShowValues: true,
    scaleValuePaddingX: 10,
    scaleValuePaddingY: 10,
     animation: {
               onComplete: function () {
                   var chartInstance = this.chart,
                   ctx = chartInstance.ctx;
                   ctx.textAlign = 'center';
                   ctx.textBaseline = 'bottom';
                   this.data.datasets.forEach(function (dataset, i) {
                       var meta = chartInstance.controller.getDatasetMeta(i);
                       meta.data.forEach(function (bar, index) {
                           var data = dataset.data[index];
                           ctx.fillText(data, bar._model.x, bar._model.y - 5);
                       });
                   });
               }
           }
    };
  lineChartData: ChartDataSets[];

  lineChartLabels: Label[] = ['January', 'February', 'March', 'April', 'May', 'June'];
  lineChartColors: Color[] = [
    // {
    //   borderColor: 'black',
    //   backgroundColor: 'rgba(255,255,0,0.28)',
    // },
  ];

  lineChartLegend = true;
  lineChartPlugins = [];
  lineChartType = 'line';

  showFiller = false;
  constructor(private exportdata:ExportService) { 
    this.yearly();
    this.pageHeading = 'Grapical Patient Registration'
  }

  ngOnInit(): void {
    this.daily();
    this.barChart();
    this.pageHeading = 'Grapical Patient Registration'
  }
  
toggleDisplayDivIf() {
  this.isShowDivIf = !this.isShowDivIf;
}


  exportexcel(): void 
    {
       let element = document.getElementById('content'); 
       this.exportdata.exportxcel(element);
     }

  public openPDF():void {
    let DATA = document.getElementById('content');
    this.exportdata.CreatePDF(DATA);
        
  }
  printComponent(cmpName) {
    let printContents = document.getElementById(cmpName).innerHTML;
    this.exportdata.printData(printContents);
    
}
barChart(){
  $('#baroption').show();
  $('#pieoption').hide();
  $('#lineoption').hide();
}
pieChart(){
  $('#baroption').hide();
  $('#pieoption').show();
  $('#lineoption').hide();
}
lineChart(){
  $('#baroption').hide();
  $('#pieoption').hide();
  $('#lineoption').show();
}
daily(){
 this.barChartLabels=['june 5', 'june 6', 'june 7', 'june 8', 'june 9', 'june 10', 'june 11'];
 this.barChartData=[
  { data: [52, 62, 70, 75, 60,80, 70], label: 'New Patient' },
  { data: [100, 162, 232, 307, 367,447, 517], label: 'Total Patient' },
];

 this.lineChartData = [
  { data: [52, 62, 70, 75, 60,80, 70], label: 'New Patient' },
  { data: [100, 162, 232, 307, 367,447, 517], label: 'Total Patient' },
];
this. lineChartLabels=['june 5', 'june 6', 'june 7', 'june 8', 'june 9', 'june 10', 'june 11'];
}
weekly(){
  
  this.barChartLabels=['week 1', 'week 2', 'week 3', 'week 4', 'week 5', 'week 6', 'week 7'];
  this.barChartData=[
    { data: [70, 60, 58, 95, 62,65, 70], label: 'New Patient' },
    { data: [110, 170, 228, 323, 385,450, 520], label: 'Total Patient' },
  ];
   
  this.lineChartData = [
    { data: [70, 60, 58, 95, 62,65, 70], label: 'New Patient' },
    { data: [110, 170, 228, 323, 385,450, 520], label: 'Total Patient' },
  ];
  this. lineChartLabels=['week 1', 'week 2', 'week 3', 'week 4', 'week 5', 'week 6', 'week 7'];
}
monthly(){
  this.barChartLabels=['June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
  this.barChartData=[
    { data: [100, 90, 110, 95,123,65, 170], label: 'New Patient' },
    { data: [110, 200, 310, 405, 528,593, 700], label: 'Total Patient' },
  ];
   
  this.lineChartData = [
    { data: [100, 90, 110, 95,123,65, 170], label: 'New Patient' },
    { data: [110, 200, 310, 405, 528,593, 700], label: 'Total Patient' },
  ];
  this. lineChartLabels=['June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
}
yearly(){           
  this.barChartLabels=['2015', '2016', '2017', '2018', '2019', '2020', '2021','2022','2023','2024','2025']; 
  this.barChartData=[
    { data: [70, 60, 50, 95, 60,65, 70,1000,400,500,600], label: 'New Patient' },
    { data: [110, 160, 210, 305, 365,420, 1400,1800,2300,2500,3000], label: 'Total Patient' },
  ]; 
  this. lineChartLabels=['2015', '2016', '2017', '2018', '2019', '2020', '2021','2022','2023','2024','2025'];
  this.lineChartData = [
    { data: [70, 60, 50, 95, 60,65, 70,1000,400,500,600], label: 'New Patient' },
    { data: [110, 160, 210, 305, 365,420, 1400,1800,2300,2500,3000], label: 'Total Patient' },
  ];
 
}

gettop_200byname(data){
console.log(data);

}

get_records_between_two_dates(){
  
}

}
